<template>
	<page enable-flex create-button @create="addHandle">
		<view-list work-type="9" view-id="10009" :search="{placeholder: '搜单据编号'}">
			<template #default="{data, index}">
				<view-doc-card :key="index" type="9" :data="data">
					<!--状态-->
					<template #status>
						<c-state dict="flowOrderStateDic" :value="data.status"></c-state>
					</template>

					<!--紧急程度-->
					<template #urgency_level>
						<c-state dict="orderUrgencyDic" :value="data.urgency_level"></c-state>
					</template>

					<!--招工类型-->
					<template #recruit_type>
						<c-state dict="recruitTypeDic" :value="data.recruit_type"></c-state>
					</template>

					<!--招工人数-->
					<template #recruit_count>
						{{data.recruit_count}}人
					</template>

					<!--上班天数-->
					<template #work_days>
						{{data.work_days}}天
					</template>
				</view-doc-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		name: 'm_app_out_sourcing_recruit',
		
		data() {
			return {
			}
		},
		
		methods: {
			addHandle() {
				this.mp.navigateWeb('/aftersales/outsource/edit')
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>